// extracted by mini-css-extract-plugin
export default {"row":"Summary_row__maJ1s","col":"Summary_col__ngSj1","placeHolderShimmer":"Summary_placeHolderShimmer__mcHub"};